import TopBar from "@/components/Topbar";
import MainContent from "@/components/MainContent";
import { DriveContext } from "@/store/DriveContext";
import axios from "axios";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Home() {
    const { user, setUser, setOnlinePlayersDetails, setOnlinePlayersCount } = useContext(DriveContext)!;
    const navigate = useNavigate();

    async function fetchData() {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/signin");
                return;
            }

            const apiUrl = "https://matrix-sggb.onrender.com";
            const response = await axios.get(`${apiUrl}/game/all`, {
                headers: {
                    Authorization: "Bearer " + token,
                },
            });

            if (response.status === 200) {
                const data = response.data;
                setUser({
                    ...user,
                    userId: data.user.userId,
                    username: data.user.username,
                    rating: data.user.rating,
                    streak: data.user.streak,
                });
                setOnlinePlayersCount(data.online_players_count);
                setOnlinePlayersDetails(data.online_players_details);
            } else {
                alert(response.data.message);
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="h-[100dvh] bg-[#0a0a12] flex flex-col overflow-hidden relative">
            <div 
              className="absolute w-[500px] h-[500px] -top-[150px] -right-[150px] rounded-full pointer-events-none" 
              style={{ background: "radial-gradient(circle, rgba(139,92,246,0.1) 0%, transparent 70%)" }}
            />
            <TopBar />
            <MainContent />
        </div>
    );
}

export default Home;